// config.js

export const SALENG_GREEN_API_PROD = "https://api.saleng.tjl.co.th";
// export const SALENG_GREEN_API_DEV = "http://localhost:8001";
export const SALENG_SHOP_API_PROD = "https://api-v2.scrapyard.tjl.co.th";
// export const SALENG_SHOP_API_PROD = "http://localhost:9002";

export const SALENG_SHOP_FIXED_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MCwidXNlcm5hbWUiOiJzZXJ2aWNlIiwic2VydmljZVRva2VuIjp0cnVlLCJpYXQiOjE3MTAwMDAwMDAsImV4cCI6NDEwMjQ0NDgwMH0.OIqPH85UzuHZTMitKPGWtvDOUzQvr1Hrg6tLJL2OFF4";


